const steps = [
  { id: 1, label: 'Brief' },
  { id: 2, label: 'Recommendations' },
  { id: 3, label: 'Shortlist' },
  { id: 4, label: 'Contract' },
  { id: 5, label: 'Invite' },
];

export default function StepsHeader({
  current,
  onJump,
}: {
  current: number;
  onJump: (step: number) => void;
}) {
  return (
    <ol className="flex flex-wrap items-center gap-x-2 gap-y-2">
      {steps.map((step, index) => {
        const done = step.id < current;
        const active = step.id === current;
        const reachable = step.id <= current;
        return (
          <li key={step.id} className="flex items-center gap-2">
            <button
              type="button"
              disabled={!reachable}
              onClick={() => reachable && onJump(step.id)}
              className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-label transition-colors ${
                active
                  ? 'border-primary-500 bg-primary-500 text-background-50'
                  : done
                    ? 'border-accent-300 bg-accent-50 text-accent-800 cursor-pointer'
                    : 'border-background-300 bg-background-50 text-foreground-400'
              }`}
            >
              <span
                className={`flex h-5 w-5 items-center justify-center rounded-full text-[11px] ${
                  active
                    ? 'bg-background-50/20'
                    : done
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-background-200'
                }`}
              >
                {done ? <i className="ri-check-line" /> : step.id}
              </span>
              {step.label}
            </button>
            {index < steps.length - 1 ? (
              <i className="ri-arrow-right-s-line text-foreground-300" />
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}